<template>
    <div class="mx-auto col-lg-4 col-md-6 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('hec.saving.comoleteTitle') }}</h3>
        </div>

        <form @submit.prevent="handleOnSubmit">
            <!-- Forthing送金設定 -->
            <div class="setting-box">
                <label>{{ $t('hec.saving.CompleteMessageText') }}</label>
            </div>

            <div class="text-center">
                <div class="pb-4 ">
                    <button type="submit" class="btn btn-primary">{{ $t('hec.saving.btnCloseText') }}</button>
                </div>
            </div>
        
        </form>
    </div>
</template>

<script>
    import UserService from '../../services/UserService';
    
    export default {
        name: 'automatic-remittance',

        data() {
            return {
                forthing_setting: '',
                ex_bonus_setting: '',
            }
        },

        async mounted() {
        },

        created() {
        },

        methods: {
            async handleOnSubmit() {
                this.$router.push('/');
            },
        }
    }
</script>

<style scoped>
    .form-group {
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .setting-box{
        text-align:center;
        margin-top: 20px;
        margin-bottom: 20px; 
    }
    .setting-title{
        width: 150px;
        text-align: right; 
    }
    .setting-value{
        width: 150px;
        text-align: left; 
    }
    .btn-primary {
        width: 115px;
        margin-top: 10px;
        margin-left: 10px;
        margin-right: 10px;
    }
    .btn-primary:hover {
        color: #fff !important;
        background-color: #350f71 !important;
        border-color: #300e66 !important;
    }
    @media (min-width: 992px){
        .col-lg-4 {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }
    @media (min-width: 768px){
        .col-md-6 {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }
    @media (min-width: 576px){
        .col-sm-12 {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }
</style>
